var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360.04 421.73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-218.55 -48.424)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 241.06,
    y: 176.99,
    width: 84.497,
    height: 192.17,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#e2ecff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.9,
      strokeWidth: 3,
      stroke: "#5374a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.83 218.13 0.53014 81.64",
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "#bccbe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.08 217.86 0.53014 81.64",
    style: {
      fill: "#bccbe8",
      strokeWidth: 5,
      stroke: "#bccbe8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.19,
    y: 99.924,
    width: 142.81,
    height: 269.49,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#ffffff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.9,
      strokeWidth: 3,
      stroke: "#5374a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2.3199,-7.4441)",
    d: "m368.18 175.91c-1.2774-1.2774-1.3352-2.2253-1.3352-21.882 0-17.516 0.15329-20.766 1.0392-22.031l1.0392-1.4837h30.538c22.862 0 30.739 0.20138 31.339 0.80112 0.58996 0.58996 0.80111 6.4747 0.80111 22.327 0 21.487-3e-3 21.527-1.4837 22.565-1.2887 0.90261-5.37 1.0392-31.043 1.0392-28.669 0-29.6-0.0402-30.895-1.3352z",
    style: {
      fill: "#e2ecff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.12,
    y: 121.32,
    width: 67.969,
    height: 49.915,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.9,
      strokeWidth: 3,
      stroke: "#5374a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.33,
    y: 201.25,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.78,
    y: 201.58,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.24,
    y: 201.58,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.33,
    y: 228.59,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.78,
    y: 228.76,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.24,
    y: 228.76,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.33,
    y: 255.93,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.78,
    y: 255.93,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.24,
    y: 255.93,
    width: 19.547,
    height: 19.53,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#bccbe8",
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.14 .0041026)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.06,
    y: 176.99,
    width: 84.497,
    height: 192.17,
    rx: 5.2,
    ry: 5.2,
    style: {
      fill: "#e2ecff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.9,
      strokeWidth: 3,
      stroke: "#5374a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.32 218.13 0.53014 81.64",
    style: {
      fill: "#bccbe8",
      strokeWidth: 5,
      stroke: "#bccbe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.93 218.21 0.53014 81.64",
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "#bccbe8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2504 0 0 1.2504 -318.69 -148.24)",
    fill: "#5374a5",
    style: {
      strokeWidth: 0.79974
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m454.26 413.95c-1.2097-2.8222-1.803-5.8372-1.5666-7.9614 0.83097-7.4675 3.3811-15.593 5.6789-18.095 0.78932-0.85935 1.436-1.6924 1.4372-1.8512 2e-3 -0.15882 0.95958-0.90924 2.1299-1.6676 1.1703-0.75836 2.1279-1.5245 2.1279-1.7026 0-0.17803 1.0054-0.61853 2.2343-0.97888 2.1406-0.62772 11.179-5.5692 12.801-6.9983 1.0798-0.95155 0.73556-2.3764-1.8156-7.515-1.1621-2.3407-2.7931-6.4273-3.6245-9.0812-1.286-4.1052-1.5167-5.4574-1.5458-9.0593-0.0528-6.5323 1.8466-12.876 4.5714-15.269 2.3584-2.0707 3.9895-2.3054 16.146-2.3232 14.572-0.0214 14.158-0.23203 12.506 6.3674-0.46879 1.8726-0.97219 5.5116-1.1187 8.0867-0.24431 4.295-0.1913 4.8051 0.64127 6.1709 0.49919 0.81887 0.90833 2.1516 0.9092 2.9616 2e-3 1.55-3.7886 10.193-5.1398 11.72-1.5283 1.7276-2.9993 5.283-2.8635 6.9215 0.12816 1.5469 0.20678 1.6156 2.898 2.5326 1.5215 0.51836 3.494 0.94926 4.3833 0.95756 1.7462 0.0163 3.6294 0.81622 4.5594 1.9368 0.32005 0.38564 1.6467 1.2405 2.9481 1.8997 4.7184 2.3901 7.2306 5.2797 8.86 10.191 0.35522 1.0707 0.89182 2.234 1.1925 2.5851 1.2603 1.472 3.2598 17.8 2.3186 18.934-0.3143 0.3787-4.9779 0.59574-17.558 0.81717-9.4216 0.16583-20.003 0.49614-23.514 0.73404-3.511 0.23789-10.788 0.60142-16.172 0.80782s-10.408 0.50064-11.166 0.65385c-1.3244 0.26776-1.412 0.19889-2.2584-1.7757z",
    style: {
      fill: "#ffffff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 3.9987
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.23 374.81-8.7311-2.9006v-0.84691c4.982-3.6636 8.2247-9.5713 8.2247-16.226v-22.213c0-1.3791-1.1155-2.4975-2.4911-2.4975h-23.198c-7.9611 0-14.438 6.4933-14.438 14.475v10.236c0 6.6549 3.2424 12.563 8.2244 16.226v0.84691l-8.7311 2.9006c-9.9191 3.2952-16.584 12.549-16.584 23.025v15.38c0 1.3792 1.1155 2.4975 2.4911 2.4975h69.325c1.3756 0 2.4911-1.1184 2.4911-2.4975v-15.38c0-10.476-6.6645-19.73-16.584-23.025zm-26.195-39.689h20.706v12.604c-1.7744 0.74425-3.6946 1.1396-5.6317 1.1396-4.5468 0-8.7528-2.0749-11.539-5.6926-0.47183-0.61239-1.1997-0.97129-1.9717-0.97129-0.77175 0-1.4999 0.3589-1.9717 0.97104-2.2689 2.9461-5.4792 4.8682-9.048 5.4808v-4.0522c0-5.2271 4.2416-9.4796 9.4556-9.4796zm-9.4558 19.716v-1.1386c4.1597-0.52673 7.9988-2.3614 11.02-5.2698 3.6159 3.4813 8.4023 5.4316 13.511 5.4316 1.9112 0 3.8117-0.28497 5.6317-0.83218v1.809c0 8.3372-6.7654 15.12-15.081 15.12s-15.081-6.7825-15.081-15.12zm21.758 18.965v3.5874c0 3.6906-2.9948 6.6934-6.6762 6.6934s-6.6762-3.0025-6.6762-6.6934v-3.5872c2.0898 0.74151 4.3358 1.1494 6.6757 1.1494 2.3404 0 4.5866-0.40785 6.6767-1.1496zm18.733 36.915v-13.71c0-1.3791-1.1155-2.4975-2.4911-2.4975s-2.4911 1.1184-2.4911 2.4975v13.71h-40.854v-13.71c0-1.3791-1.1155-2.4975-2.4911-2.4975s-2.4911 1.1184-2.4911 2.4975v13.71h-6.7624v-12.882c0-8.3195 5.2921-15.667 13.169-18.284l7.3448-2.4403v0.27773c0 6.4451 5.2299 11.688 11.658 11.688 6.4286 0 11.658-5.2433 11.658-11.688v-0.27773l7.3438 2.4401c7.8767 2.6169 13.169 9.9644 13.169 18.284v12.882z",
    style: {
      fill: "#5374a5",
      strokeWidth: 0.79974
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.27 413.53c-1.2275-2.8637-1.8296-5.9231-1.5897-8.0786 0.8432-7.5775 3.4309-15.823 5.7625-18.361 0.80094-0.872 1.4572-1.7173 1.4583-1.8785 2e-3 -0.16116 0.97371-0.92263 2.1613-1.6922 1.1876-0.76952 2.1592-1.547 2.1592-1.7276 0-0.18065 1.0202-0.62764 2.2672-0.99328 2.1721-0.63697 11.344-5.6512 12.99-7.1014 1.0957-0.96556 0.74639-2.4114-1.8423-7.6256-1.1792-2.3752-2.8343-6.5219-3.6779-9.2149-1.305-4.1657-1.5391-5.5377-1.5686-9.1927-0.0535-6.6285 1.8738-13.066 4.6387-15.493 2.3932-2.1012 4.0483-2.3394 16.384-2.3574 14.787-0.0218 14.367-0.23545 12.69 6.4612-0.47569 1.9001-0.9865 5.5927-1.1352 8.2058-0.2479 4.3582-0.1941 4.8759 0.65073 6.2618 0.50652 0.83094 0.92169 2.1833 0.92257 3.0053 2e-3 1.5728-3.8444 10.343-5.2155 11.893-1.5508 1.753-3.0434 5.3608-2.9057 7.0234 0.13006 1.5697 0.20983 1.6394 2.9407 2.5698 1.5438 0.52598 3.5454 0.96323 4.4479 0.97165 1.772 0.0165 3.6828 0.82824 4.6265 1.9654 0.32476 0.39131 1.6709 1.2588 2.9915 1.9277 4.7879 2.4253 7.337 5.3574 8.9904 10.341 0.36045 1.0865 0.90495 2.2669 1.21 2.6232 1.2789 1.4936 3.3078 18.062 2.3528 19.213-0.31893 0.38428-5.0512 0.60452-17.817 0.82921-9.5604 0.16827-20.297 0.50344-23.86 0.74484-3.5627 0.24139-10.947 0.61028-16.41 0.81971-5.4628 0.20945-10.562 0.50802-11.331 0.66348-1.344 0.2717-1.4328 0.20182-2.2917-1.8018z",
    style: {
      fill: "#ffffff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 3.9987
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.59 374.81-8.7311-2.9006v-0.84691c4.982-3.6636 8.2247-9.5713 8.2247-16.226v-22.213c0-1.3791-1.1155-2.4975-2.4911-2.4975h-23.198c-7.9611 0-14.438 6.4933-14.438 14.475v10.236c0 6.6549 3.2424 12.563 8.2244 16.226v0.84691l-8.7311 2.9006c-9.9191 3.2952-16.584 12.549-16.584 23.025v15.38c0 1.3792 1.1155 2.4975 2.4911 2.4975h69.325c1.3756 0 2.4911-1.1184 2.4911-2.4975v-15.38c0-10.476-6.6645-19.73-16.584-23.025zm-26.195-39.689h20.706v12.604c-1.7744 0.74425-3.6946 1.1396-5.6317 1.1396-4.5468 0-8.7528-2.0749-11.539-5.6926-0.47183-0.61239-1.1997-0.97129-1.9717-0.97129-0.77175 0-1.4999 0.3589-1.9717 0.97104-2.2689 2.9461-5.4792 4.8682-9.048 5.4808v-4.0522c0-5.2271 4.2416-9.4796 9.4556-9.4796zm-9.4558 19.716v-1.1386c4.1597-0.52673 7.9988-2.3614 11.02-5.2698 3.6159 3.4813 8.4023 5.4316 13.511 5.4316 1.9112 0 3.8117-0.28497 5.6317-0.83218v1.809c0 8.3372-6.7654 15.12-15.081 15.12s-15.081-6.7825-15.081-15.12zm21.758 18.965v3.5874c0 3.6906-2.9948 6.6934-6.6762 6.6934s-6.6762-3.0025-6.6762-6.6934v-3.5872c2.0898 0.74151 4.3358 1.1494 6.6757 1.1494 2.3404 0 4.5866-0.40785 6.6767-1.1496zm18.733 36.915v-13.71c0-1.3791-1.1155-2.4975-2.4911-2.4975s-2.4911 1.1184-2.4911 2.4975v13.71h-40.854v-13.71c0-1.3791-1.1155-2.4975-2.4911-2.4975s-2.4911 1.1184-2.4911 2.4975v13.71h-6.7624v-12.882c0-8.3195 5.2921-15.667 13.169-18.284l7.3448-2.4403v0.27773c0 6.4451 5.2299 11.688 11.658 11.688 6.4286 0 11.658-5.2433 11.658-11.688v-0.27773l7.3438 2.4401c7.8767 2.6169 13.169 9.9644 13.169 18.284v12.882z",
    style: {
      fill: "#5374a5",
      strokeWidth: 0.79974
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 78.23 83.468)",
    d: "m346.12 408.5c-1.8976-4.427-2.8283-9.1566-2.4575-12.489 1.3035-11.714 5.3039-24.461 8.9082-28.385 1.2382-1.348 2.2527-2.6548 2.2544-2.904 2e-3 -0.24913 1.5053-1.4263 3.3412-2.6159 1.8359-1.1896 3.338-2.3914 3.338-2.6707 0-0.27928 1.5772-0.97028 3.5049-1.5356 3.3579-0.98468 17.537-8.7362 20.081-10.978 1.6939-1.4927 1.1539-3.7279-2.848-11.789-1.8229-3.6718-4.3815-10.082-5.6857-14.245-2.0173-6.4398-2.3792-8.5608-2.4249-14.211-0.0828-10.247 2.8967-20.199 7.1709-23.951 3.6996-3.2483 6.2582-3.6165 25.328-3.6444 22.859-0.0335 22.21-0.36398 19.618 9.9884-0.73537 2.9374-1.525 8.6458-1.7548 12.685-0.38324 6.7374-0.30008 7.5377 1.006 9.6801 0.78306 1.2845 1.4249 3.3752 1.4262 4.6458 3e-3 2.4315-5.943 15.989-8.0627 18.385-2.3974 2.71-4.7049 8.2873-4.4919 10.858 0.20104 2.4266 0.32437 2.5344 4.546 3.9727 2.3866 0.81314 5.4808 1.4891 6.876 1.5021 2.7393 0.0255 5.6932 1.2804 7.1522 3.0383 0.50205 0.60494 2.5831 1.946 4.6245 2.9801 7.4016 3.7493 11.342 8.282 13.898 15.986 0.55722 1.6796 1.399 3.5044 1.8706 4.0552 1.977 2.309 5.1136 27.922 3.6372 29.701-0.49303 0.59406-7.8086 0.93453-27.543 1.2819-14.779 0.26013-31.378 0.77828-36.886 1.1515s-16.924 0.94342-25.369 1.2672c-8.4451 0.32378-16.327 0.78533-17.516 1.0257-2.0776 0.42002-2.215 0.31199-3.5427-2.7854z",
    style: {
      display: "none",
      fill: "#ffffff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m426.51 360.69-11.745-3.902v-1.1393c6.702-4.9285 11.064-12.876 11.064-21.828v-29.882c0-1.8553-1.5006-3.3598-3.3512-3.3598h-31.206c-10.71 0-19.423 8.7351-19.423 19.472v13.77c0 8.9525 4.3619 16.9 11.064 21.828v1.1393l-11.746 3.9021c-13.344 4.4329-22.309 16.881-22.309 30.974v20.689c0 1.8553 1.5006 3.3598 3.3512 3.3598h93.259c1.8505 0 3.3512-1.5045 3.3512-3.3598v-20.689c0-14.093-8.9654-26.541-22.31-30.974zm-35.239-53.392h27.855v16.956c-2.387 1.0012-4.9701 1.533-7.576 1.533-6.1165 0-11.775-2.7913-15.523-7.6579-0.63472-0.82382-1.6139-1.3066-2.6524-1.3066-1.0382 0-2.0177 0.4828-2.6524 1.3063-3.0522 3.9632-7.3709 6.5489-12.172 7.373v-5.4512c0-7.0317 5.706-12.752 12.72-12.752zm-12.72 26.522v-1.5317c5.5958-0.70858 10.76-3.1767 14.824-7.0892 4.8642 4.6832 11.303 7.3069 18.175 7.3069 2.571 0 5.1276-0.38335 7.576-1.1195v2.4335c0 11.216-9.1011 20.34-20.288 20.34s-20.287-9.1241-20.287-20.34zm29.269 25.513v4.826c0 4.9647-4.0288 9.0042-8.9811 9.0042s-8.9811-4.0391-8.9811-9.0042v-4.8256c2.8113 0.99751 5.8327 1.5462 8.9804 1.5462 3.1484 0 6.1702-0.54866 8.9818-1.5465zm25.201 49.66v-18.443c0-1.8553-1.5006-3.3598-3.3512-3.3598s-3.3512 1.5045-3.3512 3.3598v18.443h-54.959v-18.443c0-1.8553-1.5007-3.3598-3.3512-3.3598s-3.3512 1.5045-3.3512 3.3598v18.443h-9.0971v-17.329c0-11.192 7.1192-21.076 17.715-24.596l9.8806-3.2828v0.37361c0 8.6702 7.0354 15.724 15.683 15.724 8.648 0 15.683-7.0535 15.683-15.724v-0.37361l9.8792 3.2825c10.596 3.5204 17.715 13.404 17.715 24.596v17.33z",
    style: {
      fill: "#5374a5",
      strokeWidth: 0.79974
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m173.2 263.31c-10.228-2.9282-18.21-13.146-18.196-23.295l4e-3 -2.5108 3.6215-0.87108c4.3907-1.0561 8.9473-3.2321 12.152-5.803l2.3833-1.9122 3.0433 2.2979c6.2706 4.7349 13.327 6.8369 21.293 6.343 2.6125-0.16196 5.3688-0.43551 6.125-0.60789l1.3745-0.31343v2.9532c0 3.6641-1.1116 8.0477-2.8848 11.376-1.7366 3.2596-7.1431 8.6661-10.403 10.403-5.4306 2.8932-12.571 3.6415-18.513 1.9401z",
    style: {
      fill: "#f5ae86",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 5,
      stroke: "#e99372"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m126.13 319.62c0.24368-14.342 0.55675-16.373 3.4339-22.286 0.84598-1.7384 2.5849-4.2075 3.8642-5.4868 1.2793-1.2793 2.326-2.527 2.326-2.7726 0-0.9839 4.7294-4.491 8.5-6.3032 3.9046-1.8766 15.127-5.8164 15.501-5.4421 0.10347 0.10347 0.53231 1.8389 0.95298 3.8564 1.2757 6.1181 4.7936 10.698 10.546 13.728 2.8634 1.5087 3.2619 1.5807 8.75 1.5807 5.3067 0 5.9735-0.10966 8.6487-1.4225 5.6839-2.7893 9.7834-8.3201 10.911-14.72 0.30107-1.7092 0.72061-3.1076 0.93233-3.1076 1.1104 0 14.179 4.7987 16.758 6.1537 4.425 2.3243 10.678 8.7996 12.961 13.421 3.1877 6.4537 3.4008 7.7686 3.6549 22.55l0.22991 13.375h-11.096v-11.775c0-14.409-0.25433-15.225-4.7464-15.225-1.245 0-1.991 0.38779-2.9591 1.5384l-1.2944 1.5384v23.923h-68v-23.923l-1.2944-1.5384c-2.0595-2.4476-5.6053-2.0475-7.1239 0.80377-0.39488 0.74141-0.58167 4.876-0.58167 12.875v11.783h-11.097z",
    style: {
      fill: "#699eee",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 5,
      stroke: "#699eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m188.9 227.78c-4.1401-1.3238-7.2345-3.302-10.759-6.8785-4.384-4.4484-5.3318-4.4001-10.615 0.54067-3.8496 3.6001-7.8384 5.991-11.075 6.6383l-1.5657 0.31314 0.20749-5.4491c0.16775-4.4051 0.42245-5.8605 1.3295-7.5966 1.7145-3.2816 4.3737-5.9281 7.4984-7.4626l2.8303-1.3899 38.25-0.2945v20.913l-2.9078 0.81589c-3.8105 1.0692-9.5865 1.0037-13.193-0.14951z",
    style: {
      fill: "#5c4430",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 5,
      stroke: "#5c4430"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m177.5 287.81c-5.6922-1.8479-8.466-5.9122-8.4858-12.433-6e-3 -1.9938 0.15785-3.625 0.36421-3.625 0.20635 0 1.9501 0.33359 3.875 0.74132 4.449 0.94238 9.0506 0.94238 13.5 0 1.9249-0.40773 3.6686-0.74132 3.875-0.74132 0.58668 0 0.4397 6.4187-0.19552 8.5389-1.5509 5.1765-8.2148 9.0512-12.933 7.5196z",
    style: {
      fill: "#f5ae86",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 5,
      stroke: "#f5ae86"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73998 0 0 .73998 194.58 107.89)",
    style: {
      strokeWidth: 1.0808
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 78.23 83.468)",
    d: "m346.12 408.5c-1.8976-4.427-2.8283-9.1566-2.4575-12.489 1.3035-11.714 5.3039-24.461 8.9082-28.385 1.2382-1.348 2.2527-2.6548 2.2544-2.904 2e-3 -0.24913 1.5053-1.4263 3.3412-2.6159 1.8359-1.1896 3.338-2.3914 3.338-2.6707 0-0.27928 1.5772-0.97028 3.5049-1.5356 3.3579-0.98468 17.537-8.7362 20.081-10.978 1.6939-1.4927 1.1539-3.7279-2.848-11.789-1.8229-3.6718-4.3815-10.082-5.6857-14.245-2.0173-6.4398-2.3792-8.5608-2.4249-14.211-0.0828-10.247 2.8967-20.199 7.1709-23.951 3.6996-3.2483 6.2582-3.6165 25.328-3.6444 22.859-0.0335 22.21-0.36398 19.618 9.9884-0.73537 2.9374-1.525 8.6458-1.7548 12.685-0.38324 6.7374-0.30008 7.5377 1.006 9.6801 0.78306 1.2845 1.4249 3.3752 1.4262 4.6458 3e-3 2.4315-5.943 15.989-8.0627 18.385-2.3974 2.71-4.7049 8.2873-4.4919 10.858 0.20104 2.4266 0.32437 2.5344 4.546 3.9727 2.3866 0.81314 5.4808 1.4891 6.876 1.5021 2.7393 0.0255 5.6932 1.2804 7.1522 3.0383 0.50205 0.60494 2.5831 1.946 4.6245 2.9801 7.4016 3.7493 11.342 8.282 13.898 15.986 0.55722 1.6796 1.399 3.5044 1.8706 4.0552 1.977 2.309 5.1136 27.922 3.6372 29.701-0.49303 0.59406-7.8086 0.93453-27.543 1.2819-14.779 0.26013-31.378 0.77828-36.886 1.1515s-16.924 0.94342-25.369 1.2672c-8.4451 0.32378-16.327 0.78533-17.516 1.0257-2.0776 0.42002-2.215 0.31199-3.5427-2.7854z",
    style: {
      display: "none",
      fill: "#ffffff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.51 360.69-11.745-3.902v-1.1393c6.702-4.9285 11.064-12.876 11.064-21.828v-29.882c0-1.8553-1.5006-3.3598-3.3512-3.3598h-31.206c-10.71 0-19.423 8.7351-19.423 19.472v13.77c0 8.9525 4.3619 16.9 11.064 21.828v1.1393l-11.746 3.9021c-13.344 4.4329-22.309 16.881-22.309 30.974v20.689c0 1.8553 1.5006 3.3598 3.3512 3.3598h93.259c1.8505 0 3.3512-1.5045 3.3512-3.3598v-20.689c0-14.093-8.9654-26.541-22.31-30.974zm-35.239-53.392h27.855v16.956c-2.387 1.0012-4.9701 1.533-7.576 1.533-6.1165 0-11.775-2.7913-15.523-7.6579-0.63472-0.82382-1.6139-1.3066-2.6524-1.3066-1.0382 0-2.0177 0.4828-2.6524 1.3063-3.0522 3.9632-7.3709 6.5489-12.172 7.373v-5.4512c0-7.0317 5.706-12.752 12.72-12.752zm-12.72 26.522v-1.5317c5.5958-0.70858 10.76-3.1767 14.824-7.0892 4.8642 4.6832 11.303 7.3069 18.175 7.3069 2.571 0 5.1276-0.38335 7.576-1.1195v2.4335c0 11.216-9.1011 20.34-20.288 20.34s-20.287-9.1241-20.287-20.34zm29.269 25.513v4.826c0 4.9647-4.0288 9.0042-8.9811 9.0042s-8.9811-4.0391-8.9811-9.0042v-4.8256c2.8113 0.99751 5.8327 1.5462 8.9804 1.5462 3.1484 0 6.1702-0.54866 8.9818-1.5465zm25.201 49.66v-18.443c0-1.8553-1.5006-3.3598-3.3512-3.3598s-3.3512 1.5045-3.3512 3.3598v18.443h-54.959v-18.443c0-1.8553-1.5007-3.3598-3.3512-3.3598s-3.3512 1.5045-3.3512 3.3598v18.443h-9.0971v-17.329c0-11.192 7.1192-21.076 17.715-24.596l9.8806-3.2828v0.37361c0 8.6702 7.0354 15.724 15.683 15.724 8.648 0 15.683-7.0535 15.683-15.724v-0.37361l9.8792 3.2825c10.596 3.5204 17.715 13.404 17.715 24.596v17.33z",
    style: {
      fill: "#5374a5",
      strokeWidth: 1.0808
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m173.2 263.31c-10.228-2.9282-18.21-13.146-18.196-23.295l4e-3 -2.5108 3.6215-0.87108c4.3907-1.0561 8.9473-3.2321 12.152-5.803l2.3833-1.9122 3.0433 2.2979c6.2706 4.7349 13.327 6.8369 21.293 6.343 2.6125-0.16196 5.3688-0.43551 6.125-0.60789l1.3745-0.31343v2.9532c0 3.6641-1.1116 8.0477-2.8848 11.376-1.7366 3.2596-7.1431 8.6661-10.403 10.403-5.4306 2.8932-12.571 3.6415-18.513 1.9401z",
    style: {
      fill: "#f5ae86",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#e99372"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m126.13 319.62c0.24368-14.342 0.55675-16.373 3.4339-22.286 0.84598-1.7384 2.5849-4.2075 3.8642-5.4868 1.2793-1.2793 2.326-2.527 2.326-2.7726 0-0.9839 4.7294-4.491 8.5-6.3032 3.9046-1.8766 15.127-5.8164 15.501-5.4421 0.10347 0.10347 0.53231 1.8389 0.95298 3.8564 1.2757 6.1181 4.7936 10.698 10.546 13.728 2.8634 1.5087 3.2619 1.5807 8.75 1.5807 5.3067 0 5.9735-0.10966 8.6487-1.4225 5.6839-2.7893 9.7834-8.3201 10.911-14.72 0.30107-1.7092 0.72061-3.1076 0.93233-3.1076 1.1104 0 14.179 4.7987 16.758 6.1537 4.425 2.3243 10.678 8.7996 12.961 13.421 3.1877 6.4537 3.4008 7.7686 3.6549 22.55l0.22991 13.375h-11.096v-11.775c0-14.409-0.25433-15.225-4.7464-15.225-1.245 0-1.991 0.38779-2.9591 1.5384l-1.2944 1.5384v23.923h-68v-23.923l-1.2944-1.5384c-2.0595-2.4476-5.6053-2.0475-7.1239 0.80377-0.39488 0.74141-0.58167 4.876-0.58167 12.875v11.783h-11.097z",
    style: {
      fill: "#f7cd7e",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#f7cd7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m188.9 227.78c-4.1401-1.3238-7.2345-3.302-10.759-6.8785-4.384-4.4484-5.3318-4.4001-10.615 0.54067-3.8496 3.6001-7.8384 5.991-11.075 6.6383l-1.5657 0.31314 0.20749-5.4491c0.16775-4.4051 0.42245-5.8605 1.3295-7.5966 1.7145-3.2816 4.3737-5.9281 7.4984-7.4626l2.8303-1.3899 38.25-0.2945v20.913l-2.9078 0.81589c-3.8105 1.0692-9.5865 1.0037-13.193-0.14951z",
    style: {
      fill: "#f9725c",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#f9725c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m177.5 287.81c-5.6922-1.8479-8.466-5.9122-8.4858-12.433-6e-3 -1.9938 0.15785-3.625 0.36421-3.625 0.20635 0 1.9501 0.33359 3.875 0.74132 4.449 0.94238 9.0506 0.94238 13.5 0 1.9249-0.40773 3.6686-0.74132 3.875-0.74132 0.58668 0 0.4397 6.4187-0.19552 8.5389-1.5509 5.1765-8.2148 9.0512-12.933 7.5196z",
    style: {
      fill: "#f5ae86",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#f5ae86"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73998 0 0 .73998 12.94 107.92)",
    style: {
      strokeWidth: 1.0808
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 78.23 83.468)",
    d: "m346.12 408.5c-1.8976-4.427-2.8283-9.1566-2.4575-12.489 1.3035-11.714 5.3039-24.461 8.9082-28.385 1.2382-1.348 2.2527-2.6548 2.2544-2.904 2e-3 -0.24913 1.5053-1.4263 3.3412-2.6159 1.8359-1.1896 3.338-2.3914 3.338-2.6707 0-0.27928 1.5772-0.97028 3.5049-1.5356 3.3579-0.98468 17.537-8.7362 20.081-10.978 1.6939-1.4927 1.1539-3.7279-2.848-11.789-1.8229-3.6718-4.3815-10.082-5.6857-14.245-2.0173-6.4398-2.3792-8.5608-2.4249-14.211-0.0828-10.247 2.8967-20.199 7.1709-23.951 3.6996-3.2483 6.2582-3.6165 25.328-3.6444 22.859-0.0335 22.21-0.36398 19.618 9.9884-0.73537 2.9374-1.525 8.6458-1.7548 12.685-0.38324 6.7374-0.30008 7.5377 1.006 9.6801 0.78306 1.2845 1.4249 3.3752 1.4262 4.6458 3e-3 2.4315-5.943 15.989-8.0627 18.385-2.3974 2.71-4.7049 8.2873-4.4919 10.858 0.20104 2.4266 0.32437 2.5344 4.546 3.9727 2.3866 0.81314 5.4808 1.4891 6.876 1.5021 2.7393 0.0255 5.6932 1.2804 7.1522 3.0383 0.50205 0.60494 2.5831 1.946 4.6245 2.9801 7.4016 3.7493 11.342 8.282 13.898 15.986 0.55722 1.6796 1.399 3.5044 1.8706 4.0552 1.977 2.309 5.1136 27.922 3.6372 29.701-0.49303 0.59406-7.8086 0.93453-27.543 1.2819-14.779 0.26013-31.378 0.77828-36.886 1.1515s-16.924 0.94342-25.369 1.2672c-8.4451 0.32378-16.327 0.78533-17.516 1.0257-2.0776 0.42002-2.215 0.31199-3.5427-2.7854z",
    style: {
      display: "none",
      fill: "#ffffff",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.51 360.69-11.745-3.902v-1.1393c6.702-4.9285 11.064-12.876 11.064-21.828v-29.882c0-1.8553-1.5006-3.3598-3.3512-3.3598h-31.206c-10.71 0-19.423 8.7351-19.423 19.472v13.77c0 8.9525 4.3619 16.9 11.064 21.828v1.1393l-11.746 3.9021c-13.344 4.4329-22.309 16.881-22.309 30.974v20.689c0 1.8553 1.5006 3.3598 3.3512 3.3598h93.259c1.8505 0 3.3512-1.5045 3.3512-3.3598v-20.689c0-14.093-8.9654-26.541-22.31-30.974zm-35.239-53.392h27.855v16.956c-2.387 1.0012-4.9701 1.533-7.576 1.533-6.1165 0-11.775-2.7913-15.523-7.6579-0.63472-0.82382-1.6139-1.3066-2.6524-1.3066-1.0382 0-2.0177 0.4828-2.6524 1.3063-3.0522 3.9632-7.3709 6.5489-12.172 7.373v-5.4512c0-7.0317 5.706-12.752 12.72-12.752zm-12.72 26.522v-1.5317c5.5958-0.70858 10.76-3.1767 14.824-7.0892 4.8642 4.6832 11.303 7.3069 18.175 7.3069 2.571 0 5.1276-0.38335 7.576-1.1195v2.4335c0 11.216-9.1011 20.34-20.288 20.34s-20.287-9.1241-20.287-20.34zm29.269 25.513v4.826c0 4.9647-4.0288 9.0042-8.9811 9.0042s-8.9811-4.0391-8.9811-9.0042v-4.8256c2.8113 0.99751 5.8327 1.5462 8.9804 1.5462 3.1484 0 6.1702-0.54866 8.9818-1.5465zm25.201 49.66v-18.443c0-1.8553-1.5006-3.3598-3.3512-3.3598s-3.3512 1.5045-3.3512 3.3598v18.443h-54.959v-18.443c0-1.8553-1.5007-3.3598-3.3512-3.3598s-3.3512 1.5045-3.3512 3.3598v18.443h-9.0971v-17.329c0-11.192 7.1192-21.076 17.715-24.596l9.8806-3.2828v0.37361c0 8.6702 7.0354 15.724 15.683 15.724 8.648 0 15.683-7.0535 15.683-15.724v-0.37361l9.8792 3.2825c10.596 3.5204 17.715 13.404 17.715 24.596v17.33z",
    style: {
      fill: "#5374a5",
      strokeWidth: 1.0808
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m173.2 263.31c-10.228-2.9282-18.21-13.146-18.196-23.295l4e-3 -2.5108 3.6215-0.87108c4.3907-1.0561 8.9473-3.2321 12.152-5.803l2.3833-1.9122 3.0433 2.2979c6.2706 4.7349 13.327 6.8369 21.293 6.343 2.6125-0.16196 5.3688-0.43551 6.125-0.60789l1.3745-0.31343v2.9532c0 3.6641-1.1116 8.0477-2.8848 11.376-1.7366 3.2596-7.1431 8.6661-10.403 10.403-5.4306 2.8932-12.571 3.6415-18.513 1.9401z",
    style: {
      fill: "#f5ae86",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#e99372"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m126.13 319.62c0.24368-14.342 0.55675-16.373 3.4339-22.286 0.84598-1.7384 2.5849-4.2075 3.8642-5.4868 1.2793-1.2793 2.326-2.527 2.326-2.7726 0-0.9839 4.7294-4.491 8.5-6.3032 3.9046-1.8766 15.127-5.8164 15.501-5.4421 0.10347 0.10347 0.53231 1.8389 0.95298 3.8564 1.2757 6.1181 4.7936 10.698 10.546 13.728 2.8634 1.5087 3.2619 1.5807 8.75 1.5807 5.3067 0 5.9735-0.10966 8.6487-1.4225 5.6839-2.7893 9.7834-8.3201 10.911-14.72 0.30107-1.7092 0.72061-3.1076 0.93233-3.1076 1.1104 0 14.179 4.7987 16.758 6.1537 4.425 2.3243 10.678 8.7996 12.961 13.421 3.1877 6.4537 3.4008 7.7686 3.6549 22.55l0.22991 13.375h-11.096v-11.775c0-14.409-0.25433-15.225-4.7464-15.225-1.245 0-1.991 0.38779-2.9591 1.5384l-1.2944 1.5384v23.923h-68v-23.923l-1.2944-1.5384c-2.0595-2.4476-5.6053-2.0475-7.1239 0.80377-0.39488 0.74141-0.58167 4.876-0.58167 12.875v11.783h-11.097z",
    style: {
      fill: "#51c0a6",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#51c0a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m188.9 227.78c-4.1401-1.3238-7.2345-3.302-10.759-6.8785-4.384-4.4484-5.3318-4.4001-10.615 0.54067-3.8496 3.6001-7.8384 5.991-11.075 6.6383l-1.5657 0.31314 0.20749-5.4491c0.16775-4.4051 0.42245-5.8605 1.3295-7.5966 1.7145-3.2816 4.3737-5.9281 7.4984-7.4626l2.8303-1.3899 38.25-0.2945v20.913l-2.9078 0.81589c-3.8105 1.0692-9.5865 1.0037-13.193-0.14951z",
    style: {
      fill: "#f7cd7e",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#f7cd7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.79974 0 0 .79974 254.87 142.54)",
    d: "m177.5 287.81c-5.6922-1.8479-8.466-5.9122-8.4858-12.433-6e-3 -1.9938 0.15785-3.625 0.36421-3.625 0.20635 0 1.9501 0.33359 3.875 0.74132 4.449 0.94238 9.0506 0.94238 13.5 0 1.9249-0.40773 3.6686-0.74132 3.875-0.74132 0.58668 0 0.4397 6.4187-0.19552 8.5389-1.5509 5.1765-8.2148 9.0512-12.933 7.5196z",
    style: {
      fill: "#f5ae86",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 6.7569,
      stroke: "#f5ae86"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyImg);
export default __webpack_public_path__ + "static/media/Company_img.16fb786d62e90d7cb17a8606e369946c.svg";
export { ForwardRef as ReactComponent };